
sap["ls"]["preload"]["UCF_PageHeader"] = function() {/* global _assert, _trace, INFO, WARNING */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_ClassLoader */
/// <reference path="../../core/util/ClassLoader.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_Control */
/// <reference path="../core/Control.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_PageHeaderTitle */
/// <reference path="./PageHeaderTitle.js"/>

/**
 * A PageHeader control that can contain PageHeaderItems
 * @class
 * 
 *
 * @param {HMTLElement} oDomRef The ROM reference
 * @param {UCF_LS} oLS The LS instance
 */
function UCF_PageHeader(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["UCF_PageHeader"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "PageHeader.js(29): UCF_PageHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "PageHeader.js(30): UCF_PageHeader"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "PageHeader.js(31): UCF_PageHeader"); };

	UCF_Control["apply"](this, [oDomRef, oLS]);

	this["allowTextSelection"]();

};window["UCF_PageHeader"] = UCF_PageHeader; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_PageHeader"); UCF_PageHeader["_"] = {UCF_PageHeader: 0}; }; ;
UCF_PageHeader["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Control"))(); UCF_PageHeader.prototype["sClassName"] = "UCF_PageHeader";

UCF_PageHeader["prototype"]["initialize"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["initialize"]++; }; 
	this["oRetrieveAndSetLogoIcon"]();
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["initialize"] = 0; };

/**
 * @see UCF_Control.oGetInplaceEditDomRef
 * @return { UCF_HTMLElement }
 */
UCF_PageHeader["prototype"]["oGetInplaceEditDomRef"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetInplaceEditDomRef"]++; }; 
	return UCF_DomUtil["$"](this["sId"] + "-title");
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetInplaceEditDomRef"] = 0; };

/**
 *  Sets the text typed in InplaceEdit field
 * @return {string} - the text for inplaceedit
 * @see UCF_Control.sGetInplaceEditText
 */
UCF_PageHeader["prototype"]["sGetInplaceEditText"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetInplaceEditText"]++; }; 
	return this["getClientProperty"]("Title") || this["sTitle"];
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetInplaceEditText"] = 0; };

/**
 * Sets the text typed in InplaceEdit field
 * @param {string} sTitle - the text typed
 * @see UCF_Control.setInplaceEditDomRef
 */
UCF_PageHeader["prototype"]["setInplaceEditText"] = function(sTitle) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setInplaceEditText"]++; }; 
	// eslint-disable-next-line @ur/no-memory-leaks
	this["sTitle"] = sTitle;
	this["setClientProperty"]("Title", sTitle);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setInplaceEditText"] = 0; };
/**
 * Skip to the next control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onlsskipforward"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipforward"]++; }; 
	/** @type {HTMLDivElement[]} */
	var aPageHeaderItemRefs = UCF_JsUtil["arrayFrom"](
		UCF_DomUtil["querySelectorAll"](
			'[id="' + this["sId"] + '"] [sub-ct="PAHI"]'
		)
	);
	/** @type {HTMLElement} */
	var oFocusDomRef = UCF_DomUtil["oGetActiveElement"]();
	/** @type {HTMLElement} */
	var oActivePageHeaderItemRef = UCF_DomUtil["oGetSubCTElement"](oFocusDomRef);
	/** @type {HTMLElement} */
	var oResult;

	// if active item is in page header title
	// move focus to the first tabbable element in the first page header item
	if (!oActivePageHeaderItemRef && aPageHeaderItemRefs && aPageHeaderItemRefs["length"] > 0) {
		oResult = UCF_DomUtil["oGetTabbableElementForward"](aPageHeaderItemRefs[0], true);
	}

	if (oResult && UCF_DomUtil["bDomElementFocused"](oResult)) {
		oBrowserEvent["cancelBubble"]();
		oBrowserEvent["cancel"]();
	} else {
		this["handleSkipForward"](oBrowserEvent);
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipforward"] = 0; };

/**
 * Skip to the previous control
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onlsskipback"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipback"]++; }; 

	this["handleSkipBack"](oBrowserEvent);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsskipback"] = 0; };

/**
 * handles the mouse over event:
 * - initializes fields laizy
 * - applies hover effect, when title has menu associated
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onmouseover"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onmouseover"]++; }; 

	if (window["UCF_System"]["bIs508"]) return;

	var oSource = oBrowserEvent["oGetSource"](),
		oDomRefTitle = UCF_DomUtil["$"](this["sId"] + '-title');

	if (oSource !== oDomRefTitle) return;

	UCF_DomUtil["checkTooltip"](oDomRefTitle, this["sTooltip"], oDomRefTitle);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onmouseover"] = 0; };

/**
 * Writes the appropriate acc text into the tooltip
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_PageHeader["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PageHeader.js(142): onlsaccessibility"); };

	var oSource = oBrowserEvent["oGetSource"]();

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	if (oSource["getAttribute"]("tp") === "END") {
		oAccessibilityHelper["setControlType"]("PH_END");
	} else {
		oAccessibilityHelper["setText"](this["sTitle"]);
		oAccessibilityHelper["setControlType"]("PHM");
		oAccessibilityHelper["setTooltip"](this["sTooltip"]);
		oAccessibilityHelper["applyContainerEntryBehaviour"]();
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onlsaccessibility"] = 0; };

/**
 * @see UCF_DTExtension
 * @param {UCF_HTMLElement} oDTElement the lsaccessibility
 * @return {UCF_DTExtesion} the control specific DTExtension and instance of the base class UCF_DTExtesion
 * @private
 */
UCF_PageHeader["prototype"]["oGetDTExtension"] = function(oDTElement) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetDTExtension"]++; }; 
	return UCF_Control.prototype["oGetDTExtension"]["call"](this, oDTElement, UCF_ClassLoader["oGetClass"]("UCF_PageHeaderDTExtension"));
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetDTExtension"] = 0; };

/**
 * Returns a ControlInfo object for the given dom ref if the dom ref is a sub
 * control. The control info should contain the lsdata that has client access.
 * To be overwritten by the control that likes to return a control info based
 * on a dom ref contained in the control
 *
 * @private
 * @param {HTMLElement} oDomRef the element
 * @return {UCF_ControlInfo} The ControlInfo of a contained sub element within
 * this control.
 */
UCF_PageHeader["prototype"]["oGetContainedControlInfo"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetContainedControlInfo"]++; }; 
	var oTitleId = this["oDomRef"]["getAttribute"]("title_id");
	if (!oTitleId) return null;

	var oTitle = UCF_DomUtil["$"](oTitleId);
	if (oTitle === oDomRef && oDomRef["getAttribute"]("subct") === "PHT") {
		return new (UCF_ClassLoader["oGetClass"]("UCF_PageHeaderTitle"))(oTitle, this);
	} else {
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oGetContainedControlInfo"] = 0; };

UCF_PageHeader["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["destroy"]++; }; 
	UCF_Control.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["destroy"] = 0; };

/**
 * Makes the browser selection visible
 *
 * @private
 * @param {UCF_BrowserEvent} oBrowserEvent the selectstart
 */
UCF_PageHeader["prototype"]["onselectstart"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onselectstart"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "PageHeader.js(203): onselectstart"); };
	// for touch, cancel text selection
	if (oBrowserEvent["bIsTouchInteraction"]()) {
		oBrowserEvent["oDomEvent"]["returnValue"] = false;
		oBrowserEvent["cancel"]();
		oBrowserEvent["cancelBubble"]();
		return;
	}

	UCF_Control.prototype["onselectstart"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["onselectstart"] = 0; };

UCF_PageHeader["prototype"]["oRetrieveAndSetLogoIcon"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oRetrieveAndSetLogoIcon"]++; }; 
	var sLogoIconUrl = this["sGetLogoIconUrl"]();
	if (!sLogoIconUrl) return;
	if (sLogoIconUrl === 'none') return;

	var oCustomLogo = UCF_DomUtil["$"](this["sId"] + '-logocustom');
	if (oCustomLogo)
		oCustomLogo["src"] = sLogoIconUrl;
	var oStandardLogo = UCF_DomUtil["$"](this["sId"] + '-logostandard');
	var oLogo = UCF_DomUtil["$"](this["sId"] + '-logo');
	UCF_DomUtil["addClass"](oStandardLogo, 'lsLogo--hidestandard');
	UCF_DomUtil["addClass"](oLogo, 'lsLogo--customlogo');
	UCF_DomUtil["removeClass"](oCustomLogo, 'lsElement--invisible');
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["oRetrieveAndSetLogoIcon"] = 0; };

UCF_PageHeader["prototype"]["sGetLogoIconUrl"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetLogoIconUrl"]++; }; 
	/** @type {HTMLElement} */
	var oElement;
	/** @type {string} */
	var sBackgroundImage;

	oElement = document["createElement"]('div');
	oElement["className"] = 'lsPageHeader__metadata';
	UCF_DomUtil["setStyle"](oElement, {
		"position": 'absolute',
		"top": '-10000px',
		"display": 'block',
		"height": 0,
		"width": 0
	});
	UCF_DomUtil["prepend"](document["body"], oElement);

	try {
		sBackgroundImage = decodeURIComponent(
			UCF_DomUtil["sGetCurrentStyle"](oElement, 'backgroundImage')
		);

		if (typeof oElementOrClassName === 'string') {
			UCF_DomUtil["removeFromDom"](oElement);
		}

		if (sBackgroundImage && sBackgroundImage !== 'none') {
			return sBackgroundImage["substring"](5, sBackgroundImage["length"] - 2);
		} else {
			return null;
		}
	} catch (e) {
		if (__UCF_TRACE__) { UCF_Tracer.trace(WARNING, 'Error getting metadata from background-image of "' + oElement["className"] + '" (got: "' + sBackgroundImage + '"): ' + e["message"], "PageHeader.js(262): sGetLogoIconUrl"); };
		return null;
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["sGetLogoIconUrl"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_PageHeader["prototype"]["aAttributeNames"] = ["sVisibility","sTitle","sTooltip","bShowTitle","sCustomStyle","sCustomData","iHeadingLevel"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_PageHeader["prototype"]["aEventNames"] = [];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_PageHeader["prototype"]["aMethodNames"] = [];

/**
 * @private
 * @type {UCF_ClientInterfaces.E.Visibility}
 */
UCF_PageHeader["prototype"]["sVisibility"] = "VISIBLE";

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sTitle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sTooltip"] = '';

/**
 * @private
 * @type {boolean}
 */
UCF_PageHeader["prototype"]["bShowTitle"] = true;

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sCustomStyle"] = '';

/**
 * @private
 * @type {string}
 */
UCF_PageHeader["prototype"]["sCustomData"] = '';

/**
 * @private
 * @type {number}
 */
UCF_PageHeader["prototype"]["iHeadingLevel"] = 0;

//#JSCOVER_EXCL_START
/** @protected */
UCF_PageHeader["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setDefaultValues"]++; }; 
	this["sVisibility"] = "VISIBLE";
	this["sTitle"] = '';
	this["sTooltip"] = '';
	this["bShowTitle"] = true;
	this["sCustomStyle"] = '';
	this["sCustomData"] = '';
	this["iHeadingLevel"] = 0;

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Visibility", "VISIBLE", true);
		this["setClientProperty"]("Title", '', true);
		this["setClientProperty"]("Tooltip", '', true);
		this["setClientProperty"]("ShowTitle", true, true);
		this["setClientProperty"]("CustomStyle", '', true);
		this["setClientProperty"]("CustomData", '', true);
		this["setClientProperty"]("HeadingLevel", 0, true);
	}
};;if (__UCF_COVERAGE__) { UCF_PageHeader["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP

};